import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { FETCH_QUERY_KEYS } from "src/queries/consts";
import { fetchDashboardSettings } from "src/queries/services/settings";
import { fetchEarconTypes } from "src/queries/services/earcon";

export const useFetchDashboardSettings = ({ enabled = true, fullObject = false } = {}) => {
  const { pathname } = useLocation();
  return useQuery({
    queryKey: [FETCH_QUERY_KEYS.DASHBOARD_SETTINGS],
    queryFn: () => fetchDashboardSettings(pathname.includes("admin")),
    select: (data) => (fullObject ? data : data?.settings),
    staleTime: 5000,
    enabled
  });
};

export const useFetchEarconTypes = () => useQuery({
  queryKey: [FETCH_QUERY_KEYS.EARCON_TYPES],
  queryFn: fetchEarconTypes,
  staleTime: 5 * 1000 // 5 seconds
});
